const translations = {
    en: {
        news: {
            news_cards_slider: {
                title: "Check out the news in real time",
                subtitle: "Stay up to date even at the hotel: don't miss the latest news from the major newspapers",
                read: "Read"
            }
        }
    },
    de: {
        news: {
            news_cards_slider: {
                title: "Schauen Sie sich die Nachrichten in Echtzeit an",
                subtitle: "Bleiben Sie auch im Hotel auf dem Laufenden: Verpassen Sie nicht die Nachrichten aus den großen Zeitungen",
                read: "Lesen"
            }
        }
    },
    es: {
        news: {
            news_cards_slider: {
                title: "Echa un vistazo a las noticias en tiempo real.",
                subtitle: "Manténgase actualizado incluso en el hotel: no se pierda las noticias de los principales periódicos.",
                read: "Leer"
            }
        }
    },
    fr: {
        news: {
            news_cards_slider: {
                title: "Consultez les nouvelles en temps réel",
                subtitle: "Restez à jour même à l'hôtel: ne manquez pas les dernières nouvelles des principaux journaux",
                read: "Lire"
            }
        }
    },
    it: {
        news: {
            news_cards_slider: {
                title: "Leggi le news in tempo reale",
                subtitle: "Rimani aggiornato anche in hotel: non perdere le notizie delle testate principali",
                read: "Leggi"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/news/NewsCardsSlider.js